<template>
	<div>
		<!-- <div>
			<img :src="item.url"  v-for="(item,index) in imgList" style="width: 100%;" />
			
		</div> -->

		<titlecom :title="welcome"></titlecom>
		<div class="line"></div>
		<div class="font">

			<div class="flex" style="width: 80%;margin: 0 auto;">
				<div class="line" style="width: 40%;border-top: 2px solid rgba(6, 68, 154, 0.2);" ></div>
				<p   style="text-align:center;">
					<span style="font-size:24px;color: rgb(20, 90, 245);"><strong>欢迎辞</strong></span>
				</p>
				<div class="line" style="width: 40%;border-top: 2px solid rgba(6, 68, 154, 0.2);"></div>
			</div>

			<blockquote>
				<p class="MsoNormal" style="text-align:left;text-indent:24pt;">
					<span style="font-size:16px;font-family:&quot;line-height:2;"></span><span style="font-size:16px;font-family:&quot;line-height:2;">在这春暖花开，阴霾渐散的季节，我谨代表大会组委会，热烈欢迎各位来宾、各位同道参加“中华医学会第一次细菌真菌感染学术会议”！</span>
				</p>
				<p class="MsoNormal" style="text-align:left;text-indent:24pt;">
					<span style="font-size:16px;font-family:&quot;line-height:2;">由细菌、真菌引起的感染性疾病为临床常见病、多发病，分布于临床各科</span><span style="font-size:16px;font-family:&quot;line-height:2;">。细菌耐药性上升迅速，成为严峻的全球性问题；耐药菌感染严重危害人类健康，影响社会、经济发展。应对耐药细菌及真菌感染，需要多学科密切协作，需要高端的学术平台。在中华医学会的大力支持与相关领域专家的呼吁下，中华医学会细菌感染与耐药防治分会于</span><span
					 style="font-size:16px;font-family:&quot;line-height:2;">2020年初成立，该分会致力于我国细菌、真菌感染诊治和抗菌药物合理应用水平的提高。</span>
				</p>
				<p class="MsoNormal" style="text-align:left;text-indent:24.2pt;">
					<span style="font-size:16px;font-family:&quot;line-height:2;">此次会议是中华医学会细菌感染与耐药防治分会的首届年会，今后将每年举办一次。我们致力于建立一个顶级的细菌、真菌感染诊治的多学科交流平台，建成一个本领域学术水平最高的学术会议。本次会议重点聚焦当今细菌真菌感染热点话题，具体内容包括：病原微生物诊断，细菌耐药性监测及耐药机制研究，抗感染药物药效学、临床药理学研究，细菌真菌感染的诊断与治疗，抗菌药物合理应用与管理，医院感染防控等。</span>
				</p>
				<p class="MsoNormal" style="text-align:left;text-indent:24.2pt;">
					<span style="font-size:16px;font-family:&quot;line-height:2;">大会采取线下、线上相结合交流方式。诚挚欢迎感染病诊治相关的临床各科医师和从事临床微生物学、医院感染防控、临床药学、抗感染药临床药理学、抗菌药物管理、新药研发的专业人员参加本次大会！展示最新研究进展，吸取新知识，增进多学科同道间相互了解与友情！预祝大会圆满成功！</span>
				</p>
			</blockquote>
			<el-row style="width: 100%;">
				<el-col :span="5" :offset="17">
					<p style="text-align: right;margin-bottom: 10px;color: #666; font-size: 16px;">王明贵</p>
					<p style="margin-left: 3px;margin-top: 0;color: #666;font-size: 16px;text-align: right;"> 2020年10月28日</p>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	import titlecom from '@/components/title/title.vue'
	export default {
		data() {
			return {
				welcome: '欢迎辞'
			}
		},
		components: {
			titlecom
		},
		created() {
			let flag = navigator.userAgent.match(
				/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
			)
			if (flag) {
				this.$router.push({
					path: '/welcome-phone'
				})
			};
		
		},
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/style/style.scss';


	.MsoNormal {
		font-size: 15px !important;
		line-height: 30px;
		color: #666;
	}
</style>
